import React from 'react';

import PropTypes from 'prop-types';
import { SocialIcons } from 'C4';

const ContentHeader = (props) => {
  const {
    header, subtitle, social,
  } = props;

  return (
    <div className="contentHeader" id="contentHeader">
      <h3>{header}</h3>
      {props.children}
      <h6>{subtitle}</h6>
      {social && <SocialIcons />}
    </div>
  );
};

export default ContentHeader;

ContentHeader.propTypes = {
  header: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.node,
  social: PropTypes.bool,
};

ContentHeader.defaultProps = {
  header: 'CONTENT HEADER',
  subtitle: '',
  children: null,
  social: false,
};
